<script setup lang="ts">
import CustomButton from '@/core/elements/CustomButton.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BillingSuccessPanel from './BillingSuccessPanel.vue';
import type { ProductWithMeta } from '@/utils/billing';

const props = defineProps<{
  product?: ProductWithMeta;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  done: [];
  viewInvoices: [];
}>();

const { t } = useI18n();
const successTitle = computed(() => {
  const product = props.product
    ? t('billing.offers.reviewProductName', { product: t(props.product.meta.titleKey) })
    : t('general.brand');
  return t('billing.invoicePayment.successTitle', { product });
});
</script>

<template>
  <BillingSuccessPanel
    :title="successTitle"
    :description="$t('billing.invoicePayment.successDescription')"
    :body="$t('billing.invoicePayment.successThanks')"
    preserve-description-whitespace
  >
    <template #footer>
      <CustomButton type="button" theme="secondary" :disabled="disabled" @click="emit('viewInvoices')">
        {{ $t('billing.buttons.openInvoice') }}
      </CustomButton>
      <CustomButton class="w-min justify-center whitespace-nowrap" :disabled="disabled" @click="emit('done')">
        {{ $t('general.done') }}
      </CustomButton>
    </template>
  </BillingSuccessPanel>
</template>
